export function paymentList(state = [], action) {
    switch (action.type) {
        case 'PAYMENT LIST':
        console.log(action.data);
            return action.data
        default:
            return state
    }
}